module.exports = __webpack_public_path__ + "static/media/thanks.ce190f39.png";